import React, { useState } from 'react';

// Bileşenler için ikonlar
const CalculatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 h-6 w-6"><path d="M4 7V4h16v3" /><path d="M5 20h14" /><path d="M17 4v16" /><path d="M3 12h18" /><path d="M12 20V4" /></svg>
);
const SparklesIcon = ({className}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6-10.392A2 2 0 0 0 4.236 1h15.528a2 2 0 0 0 1.732 2.671l-6 10.392a2 2 0 0 0-1.437 1.437Z" /><path d="M12 22v-2" /><path d="M8.5 14.063 4.236 1H19.76l-4.264 13.063" /><path d="M12 22a2.5 2.5 0 0 1-2.5-2.5V18h5v1.5A2.5 2.5 0 0 1 12 22Z" /><path d="M12 15.5V18" /></svg>
);
const HomeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 h-5 w-5 text-slate-500"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
);
const HandshakeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 h-6 w-6"><path d="m11 17 2 2a1 1 0 1 0 1.4-1.4l-2-2"/><path d="m6 16 1.4-1.4a1 1 0 1 1 1.4 1.4L6 19"/><path d="M16 8 5 19"/><path d="m18 6-2-2a1 1 0 1 0-1.4 1.4l2 2"/><path d="m19 13-1.4 1.4a1 1 0 1 1-1.4-1.4L19 10"/><path d="M12 22s5-4 5-9-5-9-5-9-5 4-5 9 5 9 5 9z"/></svg>
);
const ClipboardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 h-5 w-5 text-slate-500"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
);


// Ana Uygulama Bileşeni
export default function App() {
  // State Değişkenleri
  const [endeks, setEndeks] = useState('');
  const [metrekare, setMetrekare] = useState('');
  const [fiyat, setFiyat] = useState('');
  const [kira, setKira] = useState('');
  const [bolgeAdi, setBolgeAdi] = useState('');
  const [daireAciklamasi, setDaireAciklamasi] = useState('');
  
  const [sonuc, setSonuc] = useState(null);
  const [oran, setOran] = useState(null);
  const [amortisman, setAmortisman] = useState(null);
  const [fiyatEtiketi, setFiyatEtiketi] = useState('');
  const [yatirimAnalizi, setYatirimAnalizi] = useState('');
  const [pazarlikStratejisi, setPazarlikStratejisi] = useState('');
  
  const [isLoading, setIsLoading] = useState(false);
  const [isStrategyLoading, setIsStrategyLoading] = useState(false);
  const [error, setError] = useState('');

  // Gemini API için genel bir fetch fonksiyonu
  const callGeminiAPI = async (prompt) => {
    try {
        const apiKey = "AIzaSyAsP7zBGNh8fx9MIgoK3LL3x3aOFhxGrCk"; // Bu alan boş bırakılmalıdır. Sistem API anahtarını otomatik olarak ekleyecektir.
        const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-05-20:generateContent?key=${apiKey}`;
        const payload = { contents: [{ parts: [{ text: prompt }] }] };
        const response = await fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(`API hatası: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`);
        }

        const data = await response.json();
        const candidate = data.candidates && data.candidates[0];
        const part = candidate && candidate.content && candidate.content.parts && candidate.content.parts[0];

        if (part && part.text) {
            return part.text;
        } else {
            throw new Error("API'den geçerli bir metin yanıtı alınamadı.");
        }
    } catch (err) {
        console.error("Gemini API çağrısı başarısız:", err);
        throw err;
    }
  };

  // Pazarlık Stratejisi Oluşturma
  const handleGenerateStrategy = async () => {
    setIsStrategyLoading(true);
    setPazarlikStratejisi('');
    const prompt = `
        Bir gayrimenkul yatırım danışmanı olarak, aşağıdaki verilere sahip bir mülk için kapsamlı bir pazarlık stratejisi oluştur. Amacın, fiyat ne olursa olsun alıcı için en avantajlı koşulları sağlamaktır.

        **Veriler:**
        - Konum: ${bolgeAdi || "Belirtilmedi"}
        - Fiyat Değerlendirmesi: ${fiyatEtiketi}
        - Fiyat Uygunluk Oranı: ${oran.toFixed(3)}
        - Brüt Metrekare: ${metrekare} m²
        - Daire Açıklaması: "${daireAciklamasi || 'Açıklama belirtilmedi.'}"
        ${amortisman ? `- Amortisman Süresi: ${amortisman.toFixed(1)} yıl` : ''}

        **Strateji Geliştirme Kuralları:**

        1.  **Duruma Göre Yaklaşım Belirle:**
            * **Eğer Fiyat 'Uygun Fiyat' ise:** Stratejiyi, "Bu harika fırsatı kaçırmadan, son bir iyi niyet indirimiyle anlaşmayı tamamlamak" üzerine kur. Argümanlar, satıcıyı hızlı bir satışa ikna etmeye yönelik olmalı.
            * **Eğer Fiyat 'Adil Fiyat' ise:** Stratejiyi, "Fiyat makul ancak her yatırımda olduğu gibi, olası riskler ve ek masraflar için bir pay ayırmak gerekli" üzerine kur. Argümanlar, küçük ama anlamlı bir indirim elde etmeye odaklanmalı.
            * **Eğer Fiyat 'Yüksek Fiyat' ise:** Stratejiyi, "Fiyatın piyasa gerçekleriyle uyumlu hale getirilmesi" üzerine kur. Argümanlar güçlü, veriye dayalı ve net bir indirim talebi içermeli.

        2.  **Pazarlık Kozlarını Belirle (Her Durumda Kullan):** Fiyat etiketinden bağımsız olarak, aşağıdaki unsurları pazarlık kozu olarak kullan:
            * **Konum Zayıflıkları:** '${bolgeAdi}' konumu için "Toplu taşımaya olan mesafe", "yakın çevrede okul/market eksikliği" gibi potansiyel dezavantajları vurgula.
            * **Fiziksel Durum ve Masraflar:** Daire açıklamasındaki "masraflı", "eski tesisat" gibi ipuçlarını veya genel olarak "binanın yaşı ve potansiyel tadilat masrafları" gibi konuları gündeme getir.
            * **Metrekare Farklılıkları:** "Brüt ve net metrekare arasındaki farkın yaratabileceği maliyet algısını" bir argüman olarak kullan.
            * **Piyasa Koşulları:** "Mevcut piyasa koşullarının alıcı lehine olduğu ve nakit alıcının satıcı için bir avantaj olduğu" temasını işle.

        **Çıktı Formatı:**
        ### Pazarlık Stratejisi
        * **Yaklaşım:** Yukarıdaki kurallara göre belirlenmiş genel tavır.
        * **Ana Argümanlar:** Duruma özel olarak belirlenmiş, madde madde 2-3 güçlü argüman.
        * **İlk Teklif:** Mevcut fiyattan yapılabilecek mantıklı bir indirim oranı önerisi ve ilk teklifin nasıl sunulacağı.

        Cevabın sadece bu formatta olsun. Profesyonel, ikna edici ve yapıcı bir dil kullan.
    `;
    try {
        const strategy = await callGeminiAPI(prompt);
        setPazarlikStratejisi(strategy);
    } catch (err) {
        setError("Pazarlık stratejisi oluşturulurken bir hata oluştu.");
    } finally {
        setIsStrategyLoading(false);
    }
  };


  // Hesaplama ve Form Gönderme Fonksiyonu
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSonuc(null); setOran(null); setAmortisman(null); setYatirimAnalizi(''); setFiyatEtiketi(''); setPazarlikStratejisi('');
    setIsLoading(true);

    const endeksNum = parseFloat(endeks);
    const metrekareNum = parseFloat(metrekare);
    const fiyatNum = parseFloat(fiyat);
    const kiraNum = parseFloat(kira);

    if (isNaN(endeksNum) || isNaN(metrekareNum) || isNaN(fiyatNum) || endeksNum <= 0 || metrekareNum <= 0 || fiyatNum <= 0) {
      setError('Lütfen Fiyat, Metrekare ve Endeks alanlarına geçerli sayılar girin.');
      setIsLoading(false);
      return;
    }

    const tahminiDeger = endeksNum * metrekareNum;
    const hesaplananOran = tahminiDeger / fiyatNum;
    setSonuc(tahminiDeger);
    setOran(hesaplananOran);
    
    let etiket = '';
    if (hesaplananOran > 1.05) etiket = 'Uygun Fiyat';
    else if (hesaplananOran < 0.95) etiket = 'Yüksek Fiyat';
    else etiket = 'Adil Fiyat';
    setFiyatEtiketi(etiket);

    let amortismanSuresi = null;
    if (!isNaN(kiraNum) && kiraNum > 0) {
        amortismanSuresi = fiyatNum / (kiraNum * 12);
        setAmortisman(amortismanSuresi);
    }
    
    try {
        const analysisPrompt = `
            Bir gayrimenkul yatırım danışmanı olarak, aşağıdaki verileri kullanarak kapsamlı bir yatırım analizi raporu oluştur.

            **Veriler:**
            - Konum: ${bolgeAdi || "Belirtilmedi"}
            - Fiyat Değerlendirmesi: ${etiket}
            - Fiyat Uygunluk Oranı: ${hesaplananOran.toFixed(3)}
            ${amortismanSuresi ? `- Amortisman Süresi: ${amortismanSuresi.toFixed(1)} yıl` : ''}
            - Daire Açıklaması: "${daireAciklamasi || 'Açıklama belirtilmedi.'}"

            **Rapor Formatı:**
            Cevabını aşağıdaki iki ana başlık altında yapılandır:

            ### Konum Profili
            Bu başlık altında, '${bolgeAdi}' konumu için aşağıdaki kriterleri, hassas ve tarafsız bir dille analiz et:
            * **Sosyokültürel Yapı ve Yaşam Tarzı:** Bölgenin genel atmosferi (sakin, hareketli, tarihi vb.), kimlere daha çok hitap ettiği (aileler, öğrenciler, profesyoneller) hakkında bir yorum yap.
            * **Güvenlik ve Çevre Algısı:** Bölgenin genel güvenlik algısı, çevresel faktörler (yeşil alanlar, gürültü seviyesi vb.) hakkında bilinen genel kanıları özetle. Spekülasyondan kaçın, genel ve bilinen gerçeklere odaklan.

            ### Kira Yatırımı Değerlendirmesi
            Bu başlık altında, tüm verileri (fiyat, kira, konum, açıklama) birleştirerek yatırımın kira geliri potansiyelini değerlendir.
            * **Analiz:** Daire açıklamasındaki ipuçlarını (yeni, masraflı, eşyalı, site içi vb.) ve hesaplanan metrikleri (fiyat oranı, amortisman) kullanarak mülkün kira potansiyelini yorumla.
            * **Sonuç:** Analizin sonunda, bu yatırımın kira geliri için uygun olup olmadığına dair net bir tavsiye ver. Bu tavsiye şu üç ifadeden biri olmalı: **"Bu yatırım, kira geliri için ÖNERİLİR."**, **"Bu yatırım, kira geliri için DİKKATLİ DEĞERLENDİRİLMELİDİR."**, veya **"Bu yatırım, kira geliri için RİSKLİ GÖRÜNMEKTEDİR."**

            Cevabın sadece bu iki başlık ve içeriklerinden oluşsun. Başka bir giriş veya sonuç cümlesi ekleme.
        `;
        
        const analysis = await callGeminiAPI(analysisPrompt);
        setYatirimAnalizi(analysis);

    } catch (err) {
        setError("Analiz oluşturulurken bir hata oluştu.");
    } finally {
        setIsLoading(false);
    }
  };

  // Formu sıfırlama fonksiyonu
  const handleReset = () => {
    setEndeks(''); setMetrekare(''); setFiyat(''); setKira(''); setBolgeAdi(''); setDaireAciklamasi('');
    setSonuc(null); setOran(null); setAmortisman(null); setYatirimAnalizi(''); setFiyatEtiketi(''); setPazarlikStratejisi('');
    setError(''); setIsLoading(false); setIsStrategyLoading(false);
  };

  return (
    <div className="bg-slate-100 min-h-screen flex items-center justify-center font-sans p-4">
      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl p-6 md:p-10 space-y-8">
        
        <div className="text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800 flex items-center justify-center">
            <SparklesIcon className="mr-3 h-8 w-8 text-indigo-500" />
            Yapay Zeka Yatırım Danışmanı
          </h1>
          <p className="text-slate-500 mt-2">Gayrimenkul kararlarınızı veriye ve yapay zekaya dayandırın.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input type="number" value={fiyat} onChange={e => setFiyat(e.target.value)} placeholder="Satış Fiyatı (TL)" className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition" required />
            <input type="number" value={kira} onChange={e => setKira(e.target.value)} placeholder="Aylık Kira (Opsiyonel)" className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition" />
            <input type="number" value={endeks} onChange={e => setEndeks(e.target.value)} placeholder="Bölge m² Ortalaması (TL)" className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition" required />
            <input type="number" value={metrekare} onChange={e => setMetrekare(e.target.value)} placeholder="Brüt Metrekare (m²)" className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition" required />
            <input type="text" value={bolgeAdi} onChange={e => setBolgeAdi(e.target.value)} placeholder="İlçe / Mahalle (Analiz için)" className="col-span-1 md:col-span-2 w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition" />
          </div>
           <div className="col-span-1 md:col-span-2">
                <label htmlFor="daireAciklamasi" className="block text-sm font-medium text-slate-700 mb-2 flex items-center"><ClipboardIcon /> Daire Açıklaması (İlan Metni)</label>
                <textarea id="daireAciklamasi" value={daireAciklamasi} onChange={e => setDaireAciklamasi(e.target.value)} placeholder="İlan açıklamasını buraya yapıştırarak analizi güçlendirin..." rows="4" className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 transition"></textarea>
            </div>
          
          {error && <p className="text-red-600 text-sm text-center pt-2">{error}</p>}

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <button type="submit" disabled={isLoading} className="w-full sm:w-auto flex items-center justify-center px-8 py-3 bg-indigo-600 text-white font-bold rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-300 transition-all duration-300 disabled:bg-indigo-300">
              <CalculatorIcon />
              {isLoading ? 'Analiz Ediliyor...' : '✨ Analiz Et'}
            </button>
            <button type="button" onClick={handleReset} className="w-full sm:w-auto px-8 py-3 bg-slate-200 text-slate-700 font-bold rounded-lg hover:bg-slate-300 focus:outline-none focus:ring-4 focus:ring-slate-300 transition">Sıfırla</button>
          </div>
        </form>

        {(sonuc !== null || isLoading) && (
          <div className="border-t-2 border-slate-200 pt-8 space-y-6 animate-fade-in">
            <h2 className="text-2xl font-bold text-slate-800 text-center flex items-center justify-center"><HomeIcon /> Analiz Sonuçları</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-center pt-4">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                    <h3 className="font-semibold text-slate-600">Tahmini Piyasa Değeri</h3>
                    <p className="text-3xl font-bold text-indigo-600 mt-2">{sonuc ? sonuc.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }) : '...'}</p>
                </div>
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                    <h3 className="font-semibold text-slate-600">Fiyat Uygunluk Oranı</h3>
                    <p className="text-3xl font-bold text-indigo-600 mt-2">{oran ? oran.toFixed(3) : '...'}</p>
                    {fiyatEtiketi && !isLoading && <p className={`text-sm font-bold mt-1 ${fiyatEtiketi === 'Uygun Fiyat' ? 'text-teal-600' : ''} ${fiyatEtiketi === 'Yüksek Fiyat' ? 'text-rose-600' : ''} ${fiyatEtiketi === 'Adil Fiyat' ? 'text-sky-600' : ''}`}>({fiyatEtiketi})</p>}
                </div>
                {amortisman !== null && (
                    <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                        <h3 className="font-semibold text-slate-600">Amortisman Süresi</h3>
                        <p className="text-3xl font-bold text-teal-600 mt-2">{amortisman ? `${amortisman.toFixed(1)} Yıl` : '...'}</p>
                    </div>
                )}
            </div>

            <div className="space-y-6">
                {isLoading && <div className="flex justify-center items-center text-slate-500"><div className="animate-spin rounded-full h-5 w-5 border-b-2 border-indigo-500 mr-3"></div>Yatırım analizi oluşturuluyor...</div>}
                
                {yatirimAnalizi && !isLoading && (
                    <div className="bg-indigo-50 p-6 rounded-xl border border-indigo-200 space-y-4">
                        {yatirimAnalizi.split('###').filter(part => part.trim()).map((part, index) => {
                            const lines = part.trim().split('\n');
                            const title = lines[0];
                            const content = lines.slice(1).join('\n');
                            const isRecommended = content.includes("ÖNERİLİR");
                            const isRisky = content.includes("RİSKLİ");
                            
                            return (
                                <div key={index}>
                                    <h3 className="flex items-center text-lg font-bold text-indigo-800">
                                        <SparklesIcon className="mr-2 h-6 w-6"/>
                                        {title}
                                    </h3>
                                    <p className="text-indigo-900 mt-2 whitespace-pre-wrap pl-8">{content}</p>
                                    {title.includes("Kira Yatırımı") && (
                                        <div className={`mt-3 text-center p-2 rounded-lg font-bold text-white ${isRecommended ? 'bg-teal-500' : isRisky ? 'bg-rose-500' : 'bg-amber-500'}`}>
                                            {isRecommended && "Sonuç: Bu yatırım kira geliri için önerilir."}
                                            {isRisky && "Sonuç: Bu yatırım kira geliri için riskli görünmektedir."}
                                            {!isRecommended && !isRisky && "Sonuç: Bu yatırım dikkatli değerlendirilmelidir."}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}

                {fiyatEtiketi && !isLoading && !pazarlikStratejisi && (
                    <div className="text-center">
                        <button onClick={handleGenerateStrategy} disabled={isStrategyLoading} className="inline-flex items-center justify-center px-6 py-3 bg-slate-600 text-white font-bold rounded-lg hover:bg-slate-700 focus:outline-none focus:ring-4 focus:ring-slate-300 transition-all duration-300 disabled:bg-slate-400">
                            <HandshakeIcon /> {isStrategyLoading ? 'Oluşturuluyor...' : '✨ Pazarlık Stratejisi Oluştur'}
                        </button>
                    </div>
                )}
                {pazarlikStratejisi && (
                     <div className="bg-slate-100 p-6 rounded-xl border border-slate-200"><h3 className="flex items-center text-lg font-bold text-slate-800"><HandshakeIcon /> Pazarlık Stratejisi</h3><div className="text-slate-700 mt-3 whitespace-pre-wrap">{pazarlikStratejisi.replace('### Pazarlık Stratejisi\n','')}</div></div>
                )}
            </div>
          </div>
        )}
      </div>
      <style>{`
        @keyframes fade-in { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in { animation: fade-in 0.5s ease-out forwards; }
      `}</style>
    </div>
  );
}
